import React, { Component } from "react";

import SAP from "../../assets/SAP.png";
import HRSS from "../../assets/HRSS.png";
import Finance from "../../assets/Finance.png";
import PublicSafety from "../../assets/PublicSafety.png";

import classnames from "classnames";

import AOS from "aos";
import "aos/dist/aos.css";

export default class JHUTeams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageBool: [true, false, false, false],
      activeImage: 0,
    };

    this.changeImageAndArrow = this.changeImageAndArrow.bind(this);
  }

  componentDidMount() {
    AOS.init({
      duration: 3500,
    });
  }

  changeImageAndArrow(num) {
    var temp = this.state.imageBool;
    temp[this.state.activeImage] = !temp[this.state.activeImage];
    temp[num] = !temp[num];

    this.setState((prevState) => ({
      imageBool: temp,
      activeImage: num,
    }));
  }

  render() {
    return (
      <div id="JHUTeams">
        <div data-aos={"zoom-in-down"} className="JHUTeams__header"> 
          Departments and Teams at Johns Hopkins Using Ziplyne
        </div>
        <div data-aos={"zoom-in-up"} className="JHUTeams__carousel">
          <div className="JHUTeams__indicators">
            <div
              className="JHUTeams__indicator"
              onClick={() => {
                this.changeImageAndArrow(0);
              }}
            >
              <div className="JHUTeams__arrow"></div>
              <div className="JHUTeams__title">SAP</div>
            </div>
            <div
              className="JHUTeams__indicator"
              onClick={() => {
                this.changeImageAndArrow(1);
              }}
            >
              <div className="JHUTeams__arrow"></div>
              <div className="JHUTeams__title">HRSS</div>
            </div>
            <div
              className="JHUTeams__indicator"
              onClick={() => {
                this.changeImageAndArrow(2);
              }}
            >
              <div className="JHUTeams__arrow"></div>
              <div className="JHUTeams__title">Public Safety</div>
            </div>
            {/* <div className = "JHUTeams__indicator"  onClick = {() => {this.changeImageAndArrow(3)}}>
                            <div className = "JHUTeams__arrow"></div>
                            <div className = "JHUTeams__title">Finance</div>
                        </div> */}
          </div>
          <div className="JHUTeams__carouselImageWrap">
            <img
              className={classnames(
                "JHUTeams__carouselImage",
                this.state.imageBool[0]
                  ? "JHUTeams__carouselImageAnimation"
                  : ""
              )}
              src={SAP}
              alt=""
            />
            <img
              className={classnames(
                "JHUTeams__carouselImage",
                this.state.imageBool[1]
                  ? "JHUTeams__carouselImageAnimation"
                  : ""
              )}
              src={HRSS}
              alt=""
            />
            <img
              className={classnames(
                "JHUTeams__carouselImage",
                this.state.imageBool[2]
                  ? "JHUTeams__carouselImageAnimation"
                  : ""
              )}
              src={PublicSafety}
              alt=""
            />
            {/* <img 
                           className = {classnames('JHUTeams__carouselImage', this.state.imageBool[3] ? 'JHUTeams__carouselImageAnimation' : '')} 
                           src = {Finance} alt=""
                       /> */}
          </div>
        </div>
      </div>
    );
  }
}
